import {
  SWAGGER_ENDPOINTS_TRANSFORM_RESPONSE,
  SWAGGER_ENDPOINTS_WHITELIST,
} from 'api/helpers/whiteList';
import { findInSwaggerWhiteList, transformResponse } from 'api/helpers/utils';
import { onErrorMap } from './shared/handlers';

const excecuteOnError = async error => {
  const { url } = error.config;

  if (findInSwaggerWhiteList(SWAGGER_ENDPOINTS_WHITELIST, url)) {
    const { errors } = error?.response?.data || {};
    const errorCode = errors?.[0]?.code || errors?.code;
    const errorHandler = onErrorMap.get(errorCode);

    if (!errorHandler) return Promise.reject(error);

    const handledResponse = await errorHandler(error);
    if (handledResponse) return handledResponse;
  }

  return Promise.reject(error);
};

const excecuteOnSuccess = res => {
  // eslint-disable-next-line no-empty
  if (findInSwaggerWhiteList(SWAGGER_ENDPOINTS_WHITELIST, res.config.url)) {
  }

  if (
    findInSwaggerWhiteList(SWAGGER_ENDPOINTS_TRANSFORM_RESPONSE, res.config.url)
  ) {
    transformResponse(res, res.config.url);
  }
  return res;
};

export default apiCall => {
  apiCall.interceptors.response.use(excecuteOnSuccess, excecuteOnError);
};
